// extracted by mini-css-extract-plugin
export default {"root":"root---lo5W2"};